// Central place to edit phone / whatsapp / email.
// Replace these values with the real ones in production.

export const COMPANY_NAME = "Pronto Intervento 24H";
export const LEGAL_NAME = "S.G. di Shakirovski";
export const VAT_NUMBER = "02913480345";
export const COMPANY_ADDRESS = "Via Fratelli Cairoli 8, 43036 Fidenza (PR)";
export const PEC_EMAIL = "giulio91@pec.it";

// Display phone (with formatting)
export const PHONE_DISPLAY = "+39 347 219 2991";
// tel: link — digits only (with country code, no spaces)
export const PHONE_TEL = "+393472192991";
// WhatsApp: international format, no plus, no spaces
export const WHATSAPP_NUMBER = "393472192991";

export const EMAIL = "info@prontointervento24h.it";

export const WHATSAPP_DEFAULT_MESSAGE =
  "Ciao, ho bisogno di un pronto intervento. Potete aiutarmi?";

export const whatsappLink = (msg = WHATSAPP_DEFAULT_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const telLink = `tel:${PHONE_TEL}`;
